import axios from "axios";
import { IP } from "./config";
// 新增
export async function addSku(skuForm) {
         var resp = await axios.post(`${IP}/sku/add`, {
           ...skuForm,
         });
         return resp.data;
       }

// 查询
export async function selectSku(productId) {
  var resp = await axios.post(`${IP}/sku/select`, {
    productId,
  });
  return resp.data;
}

// 删除
export async function deleteSku(id) {
  var resp = await axios.post(`${IP}/sku/delete`, {
    id,
  });
  return resp.data;
}
